import { ApolloError } from '@apollo/client';

import { useErpCareerSkillsQuery } from 'core/graphql';

import { ICareerSkill } from './careerModel';

// Stable empty fallback — see the note in `useCareerMembers`.
const EMPTY_SKILLS: ICareerSkill[] = [];

interface ICareerSkillsHook {
  skills: ICareerSkill[];
  loading: boolean;
  error?: ApolloError;
}

/**
 * Spec 0018 increment B — the skill reference list for the vacancy-form
 * multiselect. The whole catalogue is small, so it is fetched once and
 * filtered client-side inside the picker rather than round-tripping a `search`
 * per keystroke.
 *
 * ⚠️ Reads `careerSkillsErp`, not `careerSkills` (spec 0034). The latter lives
 * in the LMS scope gated on the Student role, so with an ERP token it raised
 * PermissionDenied, `data` came back undefined, and this hook silently fell
 * through to the empty array — the multiselect had been rendering empty ever
 * since increment B, with nothing on screen to say why.
 */
export const useCareerSkills = (): ICareerSkillsHook => {
  const { data, loading, error } = useErpCareerSkillsQuery({
    fetchPolicy: 'cache-and-network',
  });

  return {
    skills: data?.careerSkillsErp ?? EMPTY_SKILLS,
    loading,
    error,
  };
};
